export var TypeActionPlayerSettingsInfo;
(function (TypeActionPlayerSettingsInfo) {
    TypeActionPlayerSettingsInfo["Received"] = "PlayerSettingsInfo > Received";
    TypeActionPlayerSettingsInfo["ToggleAnimation"] = "PlayerSettingsInfo > ToggleAnimation";
    TypeActionPlayerSettingsInfo["SetAutoAnimation"] = "PlayerSettingsInfo > SetAutoAnimation";
    TypeActionPlayerSettingsInfo["BlogVersionReceived"] = "PlayerSettingsInfo > BlogVersionReceived";
    TypeActionPlayerSettingsInfo["ViewBlog"] = "PlayerSettingsInfo > ViewBlog";
    TypeActionPlayerSettingsInfo["SetSound"] = "PlayerSettingsInfo > SetSound";
})(TypeActionPlayerSettingsInfo || (TypeActionPlayerSettingsInfo = {}));
export var actionPlayerSettingsInfo = function (props) { return ({
    playerSettingsInfo: props,
    type: TypeActionPlayerSettingsInfo.Received,
}); };
export var actionPlayerSettingsToggleAnimation = function (animationEnabled) { return ({
    animationEnabled: animationEnabled,
    type: TypeActionPlayerSettingsInfo.ToggleAnimation,
}); };
export var actionPlayerSettingsSetAutoAnimation = function () { return ({
    type: TypeActionPlayerSettingsInfo.SetAutoAnimation,
}); };
export var actionPlayerSettingsBlogVersionReceived = function (version) { return ({
    type: TypeActionPlayerSettingsInfo.BlogVersionReceived,
    version: version,
}); };
export var actionPlayerSettingsViewBlog = function () { return ({
    type: TypeActionPlayerSettingsInfo.ViewBlog,
}); };
export var actionPlayerSettingsSetSound = function (soundGroup, enabled) { return ({
    enabled: enabled,
    soundGroup: soundGroup,
    type: TypeActionPlayerSettingsInfo.SetSound,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/info/player-settings/actionPlayerSettingsInfo.ts
// module id = 159
// module chunks = 3